<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex justify-between min-[525px]:items-center my-3">

  <h2>View Fleet</h2>
  <div class="flex flex-col-reverse min-[525px]:flex-row gap-2">
    <button nz-button class="outline-button" (click)="activeFilter()">{{ filterActiveStatus ? 'Show' : 'Hide' }}
      Inactive
    </button>
    <button *appHasAnyPrivilege="'FLEET_CREATE'" nz-button nzType="primary" (click)="goto(undefined,'update')">Add
      New Vehicle
    </button>
  </div>
</div>
<nz-card>
  <div class="flex flex-col gap-3">
    <div [ngClass]="loading ? 'hidden' : 'block'">
      <nz-collapse>
        <nz-collapse-panel [nzHeader]="'Advanced Search'">
          <div class="flex flex-col lg:flex-row lg:justify-between ">
            <div class="flex flex-wrap mx-1 lg:mx-0">
              <div class="flex w-full lg:w-auto flex-col lg:flex-row lg:items-center gap-4">
                <nz-form-label class="flex custom_filter">Filter by Availability Status</nz-form-label>

                <nz-select class="custom_filter"
                           [(ngModel)]="filterAvailabilityStatus"
                           (ngModelChange)="search()"
                           nzPlaceHolder="Select  Status"
                           [nzAllowClear]="true"
                >
                  <nz-option *ngFor="let st of filterAvailabilityStatusPairs" nzLabel="{{st.label}}"
                             nzValue="{{st.value}}"></nz-option>
                </nz-select>
                <nz-divider
                  class="hidden lg:block"
                  [nzType]="'vertical'"
                ></nz-divider>
              </div>

              <div class="flex w-full lg:w-auto flex-col lg:flex-row lg:items-center">
                <nz-form-label class="flex">Filter by Wash Status</nz-form-label>

                <nz-select
                  [(ngModel)]="filterWashStatus"
                  (ngModelChange)="search()"
                  nzPlaceHolder="Select Status"
                  [nzAllowClear]="true"
                >
                  <nz-option *ngFor="let st of washStatusPairs" nzLabel="{{st.label}}"
                             nzValue="{{st.value}}"></nz-option>
                </nz-select>
                <nz-divider
                  class="hidden lg:block"
                  [nzType]="'vertical'"
                ></nz-divider>
              </div>

              <div class="flex w-full lg:w-auto lg:mt-2 flex-col lg:flex-row lg:items-center">
                <nz-form-label class="flex">Filter by Service Due Status</nz-form-label>
                <nz-select
                  [(ngModel)]="filterServiceDueStatus"
                  (ngModelChange)="search()"
                  nzPlaceHolder="Select Status"
                  [nzAllowClear]="true"
                >
                  <nz-option nzLabel="Due" nzValue="DUE"></nz-option>
                  <nz-option nzLabel="Normal" nzValue="NORMAL"></nz-option>
                  <nz-option nzLabel="Over Due" nzValue="OVER_DUE"></nz-option>
                </nz-select>
                <nz-divider
                  class="hidden lg:block"
                  [nzType]="'vertical'"
                ></nz-divider>
              </div>

              <div class="flex w-full lg:mt-2 lg:w-auto justify-start flex-col lg:flex-row lg:items-center">
                <nz-form-label class="flex">Filter by T-Oil change Due Status</nz-form-label>
                <!--                <label class="flex sm:hidden">Filter by T-Oil change Due </label>-->
                <!--                <label class="flex mb-1 sm:hidden" style="margin-top: 0">Status:</label>-->

                <nz-select
                  [(ngModel)]="filterOilChangeDueStatus"
                  (ngModelChange)="search()"
                  nzPlaceHolder="Select Status"
                  [nzAllowClear]="true"
                >
                  <nz-option nzLabel="Due" nzValue="DUE"></nz-option>
                  <nz-option nzLabel="Normal" nzValue="NORMAL"></nz-option>
                  <nz-option nzLabel="Over Due" nzValue="OVER_DUE"></nz-option>
                </nz-select>
                <nz-divider
                  class="hidden lg:block"
                  [nzType]="'vertical'"
                ></nz-divider>
              </div>

              <div class="flex w-full lg:w-auto mt-2 lg:order-last lg:items-center">
                <div class="flex w-full flex-col lg:flex-row lg:items-center">
                  <nz-input-group style="max-width: 500px" nzSearch [nzAddOnAfter]="suffixIconSearchButton">
                    <input
                      type="text"
                      [(ngModel)]="searchText"
                      nz-input
                      placeholder="Search Fleets"
                      (keydown.enter)="search()"
                    />
                  </nz-input-group>
                  <ng-template #suffixIconSearchButton>
                    <button
                      nz-button
                      nzType="primary"
                      (click)="search()"
                      nzSearch
                      class="bg-[#6B6C6E] border-[#6B6C6E] "
                    >
                      <span nz-icon nzType="search"></span>
                    </button>
                  </ng-template>
                </div>
                <nz-divider
                  class="hidden lg:block"
                  [nzType]="'vertical'"
                ></nz-divider>
              </div>

              <div class="flex w-full lg:w-auto mt-2 lg:order-last lg:items-center">
                <div class="flex w-full flex-col lg:flex-row lg:items-center">
                  <nz-input-group style="max-width: 500px" nzSearch [nzAddOnAfter]="suffixIconResetButton">
                    <nz-range-picker [(ngModel)]="dateRangesCreated"
                                     (ngModelChange)="onChangeCreatedDateFilter($event)"></nz-range-picker>
                  </nz-input-group>
                  <ng-template #suffixIconResetButton>
                    <button
                      [disabled]="!(this.dateRangesCreated.length > 0)"
                      nz-button
                      nzType="primary"
                      (click)="resetSearch('date')"
                      nzSearch
                      class="bg-[#6B6C6E] border-[#6B6C6E] "
                    >
                      <span nz-icon nzType="close-circle"></span>
                    </button>
                  </ng-template>
                </div>
              </div>
            </div>

            <div class="flex items-end mx-1 lg:mx-0 lg:mt-0 mt-2" style="text-align: right;">
              <button nz-button class="outline-button reset-button" (click)="resetSearch()">
                Reset All
              </button>
            </div>

          </div>
        </nz-collapse-panel>
      </nz-collapse>
    </div>

    <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card">
      <div class="table-obj">
        <nz-table
          #fleetTable
          [nzData]="fleetData"
          [nzShowSizeChanger]="pageSize.length > 5"
          [nzPageSizeOptions]="pageSize.pageSizeOptions"
          [nzPageSize]="pageSize.pageSize"
          [nzLoading]="loading"
          [nzPageIndex]="pageSize.pageIndex"
          [nzFrontPagination]="false"
          [nzTotal]="pageSize.length"
          (nzQueryParams)="onTableParamsChange($event)"
          nzTableLayout="fixed"
          [nzScroll]="{ x: 'auto', y: '550px' }"
          nzOuterBordered
        >
          <thead>
          <tr>
            <th>Vehicle ID</th>
            <th>Type</th>
            <th >Brand</th>
            <th>Model</th>
            <th>Reg No</th>
            <th>Return Date and Time</th>
            <th >Next Booking Date and Time</th>
            <th >Current Fuel %</th>
            <th>Current Mileage</th>
            <th>Next Service Due In</th>
            <th>Service Due</th>
            <th nz-tooltip nzTooltipTitle="Next Transmission Oil Change Due">Next T-Oil Due In</th>
            <th nz-tooltip nzTooltipTitle="Transmission Oil Change Due Status">T-Oil Change Due</th>
            <th>Wash Status</th>
            <th>Availability</th>
            <!--            <th style="width: 150px">Status</th>-->
            <th>
              <div class="flex">
                <span>Created Date</span>
                <span *ngIf="sortOrder === -1" nz-icon nzType="up" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
                <span *ngIf="sortOrder === 1" nz-icon nzType="down" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
              </div>
            </th>
            <th
              *appHasAnyPrivilege="'FLEET_UPDATE,FLEET_SINGLE_VIEW,REPAIR_RECORDS_CREATE,SERVICE_RECORDS_CREATE,FLEET_DELETE'"
            >Action
            </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let data of fleetTable.data">
            <td style="min-width: 100px">
              <a *appHasAnyPrivilege="'FLEET_SINGLE_VIEW'"
                 (click)="goto(data._id, 'view')">{{ data?.refNo ? data?.refNo : '-' }}</a>
              <span *ngIf="!hasPermission('FLEET_SINGLE_VIEW')">{{ data?.refNo ? data?.refNo : '-' }}</span>
            </td>
            <td style="min-width: 150px">{{ data?.generalInformation?.vehicleType ? (data?.generalInformation?.vehicleType === 'SR' ? 'SR Vehicle' : 'Rented Vehicle') : '-' }}
            </td>
            <td style="min-width: 150px">{{ data?.vehicleDetails?.vehicleBrand ? data?.vehicleDetails?.vehicleBrand : '-' }}
            </td>
            <td style="min-width: 150px"
            >{{ data?.vehicleDetails?.vehicleModel ? data?.vehicleDetails?.vehicleModel : '-' }}
            </td>
            <td style="min-width: 150px"
            >{{ data?.vehicleDetails?.registrationNumber ? data?.vehicleDetails?.registrationNumber : '-' }}
            </td>
            <td style="min-width: 150px"
           >{{ data?.lastReturnDateBookings?.length > 0 ? ((getBookingDateAndTime(data?.lastReturnDateBookings, 'ongoing') | date: 'dd-MM-y') + ' | ' + (getBookingDateAndTime(data?.lastReturnDateBookings, 'ongoing') | date: 'hh:mm:a')) : '-' }}
            </td>
            <td style="min-width: 250px"
            >{{ (data?.upcomingBookings?.length > 0) ? ((getBookingDateAndTime(data?.upcomingBookings, 'upcoming') | date: 'dd-MM-y') + ' | ' + (getBookingDateAndTime(data?.upcomingBookings, 'upcoming') | date: 'hh:mm:a')) : '-' }}
            </td>
            <td style="min-width: 150px;">{{ data?.currentFuelLevel ? (data?.currentFuelLevel | unit : '%') : '-' }}
            </td>
            <td style="min-width: 150px;">{{ data?.currentMileage | unit }}</td>
            <td style="min-width: 200px;">{{ (data?.vehicleInventory?.latestServiceMileage + data?.vehicleInventory?.serviceDuration) | unit }}
            </td>
            <td style="min-width: 150px">
              <nz-tag
                *ngIf="(((data?.vehicleInventory?.latestServiceMileage + data?.vehicleInventory?.serviceDuration)  - data?.currentMileage) < 0)"
                [nzColor]="'#F3454C'" class="rounded-full"
              >Over Due
              </nz-tag>
              <nz-tag
                *ngIf="((((data?.vehicleInventory?.latestServiceMileage + data?.vehicleInventory?.serviceDuration)  - data?.currentMileage) <= 1000) && (((data?.vehicleInventory?.latestServiceMileage + data?.vehicleInventory?.serviceDuration)  - data?.currentMileage) >= 0))"
                [nzColor]="'#FF8C00'" class="rounded-full"
              >Due
              </nz-tag>
              <nz-tag
                *ngIf="(((data?.vehicleInventory?.latestServiceMileage + data?.vehicleInventory?.serviceDuration)  - data?.currentMileage) > 1000)"
                [nzColor]="'#52C41A'" class="rounded-full"
              >Normal
              </nz-tag>
              <!--              <span-->
              <!--                *ngIf="(!data?.vehicleInventory?.latestServiceMileage || !data?.vehicleInventory?.serviceDuration || !data?.currentMileage)">-</span>-->
            </td>
            <td style="min-width: 150px">{{ (data?.vehicleInventory?.latestOilChangedMileage + data?.vehicleInventory?.oilChangeDuration) | unit }}
            </td>
            <td style="min-width: 200px" >
              <nz-tag
                *ngIf="(((data?.vehicleInventory?.latestOilChangedMileage + data?.vehicleInventory?.oilChangeDuration)  - data?.currentMileage) < 0)"
                [nzColor]="'#F3454C'" class="rounded-full"
              >Over Due
              </nz-tag>
              <nz-tag
                *ngIf="((((data?.vehicleInventory?.latestOilChangedMileage + data?.vehicleInventory?.oilChangeDuration)  - data?.currentMileage) <= 1000) && (((data?.vehicleInventory?.latestOilChangedMileage + data?.vehicleInventory?.oilChangeDuration)  - data?.currentMileage) >= 0))"
                [nzColor]="'#FF8C00'" class="rounded-full"
              >Due
              </nz-tag>
              <nz-tag
                *ngIf="(((data?.vehicleInventory?.latestOilChangedMileage + data?.vehicleInventory?.oilChangeDuration)  - data?.currentMileage) > 1000)"
                [nzColor]="'#52C41A'" class="rounded-full"
              >Normal
              </nz-tag>
            </td>
            <td style="white-space: nowrap; min-width: 150px">
              <nz-tag *ngIf="data.washStatus === washStatus.READY" [nzColor]="'#52C41A'" class="rounded-full"
              >Ready
              </nz-tag
              >
              <nz-tag *ngIf="data.washStatus === washStatus.DIRTY" [nzColor]="'#F3454C'" class="rounded-full"
              >Dirty
              </nz-tag
              >
              <nz-tag *ngIf="data.washStatus === washStatus.WASHED" [nzColor]="'#2A7CF5'" class="rounded-full"
              >Washed
              </nz-tag
              >
            </td>
            <td>
              <nz-tag *ngIf="data?.availabilityStatus === availabilityStatus.AVAILABLE" [nzColor]="'#3ab200'"
                      class="rounded-full"
              >Available
              </nz-tag
              >
              <nz-tag *ngIf="data?.availabilityStatus === availabilityStatus.ON_TRANSFER" [nzColor]="'#FF8C00'"
                      class="rounded-full"
              >On Transfer
              </nz-tag
              >
              <nz-tag *ngIf="data?.availabilityStatus === availabilityStatus.ON_RENT" [nzColor]="'#2A7CF5'"
                      class="rounded-full"
              >On Rent
              </nz-tag
              >
              <nz-tag *ngIf="data?.availabilityStatus === availabilityStatus.OUT_OF_SERVICE" [nzColor]="'#F3454C'"
                      class="rounded-full"
              >Out of Service
              </nz-tag
              >
              <!--              <nz-tag *ngIf="data?.availabilityStatus === availabilityStatus.ON_SERVICE" [nzColor]="'#f8db1b'"-->
              <!--                      class="rounded-full"-->
              <!--              >On Service-->
              <!--              </nz-tag-->
              <!--              >-->
              <nz-tag *ngIf="data?.availabilityStatus === availabilityStatus.ON_OTHER_TOUR" [nzColor]="'#ae1bf8'"
                      class="rounded-full"
              >On Other Tour
              </nz-tag
              >
            </td>
            <td style="min-width: 150px">{{ data?.createdAt | date: 'dd-MM-y' }}</td>
            <td
              *appHasAnyPrivilege="'FLEET_UPDATE,FLEET_SINGLE_VIEW,REPAIR_RECORDS_CREATE,SERVICE_RECORDS_CREATE,FLEET_DELETE'"
              >
              <button *appHasAnyPrivilege="'FLEET_UPDATE'" [disabled]="!data?.active"
                      [class.outline-button]="data.active" (click)="goto(data._id, 'update')"
                      class="mr-3" nz-button nzType="default">
                Edit
              </button>
              <button
                *appHasAnyPrivilege="'FLEET_UPDATE,FLEET_SINGLE_VIEW,REPAIR_RECORDS_CREATE,SERVICE_RECORDS_CREATE,FLEET_DELETE'"
                class="outline-button more-dropdown"
                nz-button
                nz-dropdown
                [nzDropdownMenu]="menu"
                nzPlacement="bottomRight"
              >
                <span nz-icon nzType="more" nzTheme="outline"></span>
              </button>
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                  <li *appHasAnyPrivilege="'FLEET_SINGLE_VIEW'" nz-menu-item nz-popconfirm nz-button
                      (click)="goto(data._id, 'view')">View Vehicle
                  </li>
                  <li *appHasAnyPrivilege="'REPAIR_RECORDS_CREATE'" nz-menu-item nz-popconfirm nz-button
                      (click)="goto(data._id, 'repair')">Repair Now
                  </li>
                  <li *appHasAnyPrivilege="'SERVICE_RECORDS_CREATE'" nz-menu-item nz-popconfirm nz-button
                      (click)="goto(data._id, 'service')">Service Now
                  </li>
                  <!--                  <li *appHasAnyPrivilege="'FLEET_UPDATE'" nz-menu-item nz-popconfirm nz-button nz-dropdown-->
                  <!--                      [nzDropdownMenu]="availableMenu"-->
                  <!--                      nzPlacement="bottomRight">-->
                  <!--                    Change Availability Status-->
                  <!--                  </li>-->
                  <li *appHasAnyPrivilege="'FLEET_CHANGE_AVAILABILITY'" nz-submenu nzTitle="Change Availability Status">
                    <ul>
                      <li nz-menu-item *ngFor="let st of availabilityStatusPairs" nz-popconfirm
                          nzPopconfirmTitle="Are you sure you want change status to {{st.label}} in this fleet?"
                          (nzOnConfirm)="changeAvailabilityStatus(st.value, data._id)"
                          (nzOnCancel)="cancel()">{{ st.label }}
                      </li>
                    </ul>
                  </li>
                  <!--                  <li *appHasAnyPrivilege="'FLEET_UPDATE'" nz-menu-item nz-popconfirm nz-button nz-dropdown-->
                  <!--                      [nzDropdownMenu]="washStatusMenu"-->
                  <!--                      nzPlacement="bottomLeft">-->
                  <!--                    Change Wash Status-->
                  <!--                  </li>-->
                  <li *appHasAnyPrivilege="'FLEET_CHANGE_WASH_STATUS'" nz-submenu nzTitle="Change Wash Status">
                    <ul>
                      <li nz-menu-item *ngFor="let st of washStatusPairs" nz-popconfirm
                          nzPopconfirmTitle="Are you sure you want change the wash status to {{st.label}} in this fleet?"
                          (nzOnConfirm)="changeWashStatus(st.value, data._id)"
                          (nzOnCancel)="cancel()">{{ st.label }}
                      </li>
                    </ul>
                  </li>
                  <li *appHasAnyPrivilege="'FLEET_DELETE'"
                      nz-menu-item
                      nz-popconfirm
                      nz-button
                      nzDanger
                      nzPopconfirmTitle="Are you sure you want to delete {{data.refNo}} vehicle?"
                      (nzOnConfirm)="deleteFleet(data._id)" (nzOnCancel)="cancel()"
                  >
                    Delete
                  </li>
                </ul>
              </nz-dropdown-menu>
              <!--              <nz-dropdown-menu #availableMenu="nzDropdownMenu">-->
              <!--                <ul nz-menu>-->
              <!--                  <li nz-menu-item *ngFor="let st of availabilityStatusPairs" nz-popconfirm-->
              <!--                      nzPopconfirmTitle="Are you sure you want change status to {{st.label}} in this fleet?"-->
              <!--                      (nzOnConfirm)="changeAvailabilityStatus(st.value, data._id)"-->
              <!--                      (nzOnCancel)="cancel()">{{st.label}}</li>-->
              <!--                </ul>-->
              <!--              </nz-dropdown-menu>-->
              <!--              <nz-dropdown-menu #washStatusMenu="nzDropdownMenu">-->
              <!--                <ul nz-menu>-->
              <!--                  <li nz-menu-item *ngFor="let st of washStatusPairs" nz-popconfirm-->
              <!--                      nzPopconfirmTitle="Are you sure you want change the wash status to {{st.label}} in this fleet?"-->
              <!--                      (nzOnConfirm)="changeWashStatus(st.value, data._id)"-->
              <!--                      (nzOnCancel)="cancel()">{{st.label}}</li>-->
              <!--                </ul>-->
              <!--              </nz-dropdown-menu>-->
            </td>
          </tr>
          </tbody>
        </nz-table>
      </div>
    </div>

    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-table-skeleton-template [columnData]="skeletonTableColumns"></app-table-skeleton-template>
    </div>
  </div>
</nz-card>

<app-current-fuel-and-mileage-update-popup [isVisibleFuelAndMileageUpdate]="isVisibleModal"
                                           (currentFuelAndMileageUpdateOnChange)="onGetUpdateFuelAndMileage($event)"></app-current-fuel-and-mileage-update-popup>
